/**
 * 相對時間顯示（3 小時前 / 昨天 / 2026/07/31），超過 7 天自動改絕對日期。
 *
 * 為什麼是元件而不是直接呼叫 useRelativeTime：留言、貼文列表都是在 .map() 裡渲染，
 * hook 不能在迴圈中呼叫。包成元件後每一筆自己是一個元件實例，各自持有自己的計時器。
 *
 * 用 <time> 而非 <span>：畫面文字是本地時間，dateTime 屬性依 HTML 規範放機器可讀的
 * 絕對時間點（ISO 8601），title 給滑鼠停留時的精確時間——相對時間再方便，
 * 使用者想確認確切時間時仍要看得到，這是社群平台的通例。
 *
 * 樣式由呼叫端決定：<time> 與 <span> 同為 inline，沿用外層既有的 class 即可。
 */
import { memo } from 'react';
import { useRelativeTime } from '@/hooks/useRelativeTime';
import { toIsoString } from '@/shared/utils/formatDate';

// memo：這個元件掛在最容易被父層連帶重繪的位置——在留言輸入框打字時，每個按鍵都會讓
// 該卡片底下所有留言的時間重算一輪。props 只有一個字串，天然適合 memo；
// 加上之後只有真正 tick 到的那一個實例會重算
const RelativeTime = memo(function RelativeTime({ value }) {
  const { text, title } = useRelativeTime(value);

  // 後端合法地回傳空值時不渲染空標籤
  if (!text) return null;

  // 樣式一律由外層容器決定（.time / <small>），不開 className prop：
  // 目前 5 個呼叫端都靠繼承，需要時再加
  return (
    <time dateTime={toIsoString(value)} title={title}>
      {text}
    </time>
  );
});

export default RelativeTime;
